export default {
  user: {
    confirmDelete: "确定删除用户[{name}]吗?",
    info: "用户信息",
    title: "用户权限管理",
    resetPassword: "重置密码",
    email: "邮箱",
    name: "姓名",
    username: "用户名",
    phoneNumber: "手机",
    rolesTitle: "用户角色",
    rolesPlaceholder: "角色",
    addUser: "新建用户信息",
    editUser: "编辑用户信息",
    DuplicateUser: "不可重复添加用户",
    confirmPasswordSameValidation: "两次输入密码不一致",
    emailFormatValidation: "请输入正确的邮箱地址",
    userRolesValidation: "请选择角色",
    userAddedSuccessfully: "添加用户成功",
    userUpdatedSuccessfully: "修改用户成功",
    userDeletedSuccessfully: "删除用户成功",
    userDeletedUnsuccessfully: "删除用户失败",
    canNotDeleteAdmin: "无法删除管理员账户",
    operationFailure: "操作失败",
    passwordValidation: "请输入密码",
    confirmPasswordRequiredValidation: "请再次输入密码",
    passwordResetSuccessfully: "修改密码成功",
    password: "密码",
    emailValidation: "请输入邮箱",
    confirmPassword: "确认密码",
    nameValidation: "请输入姓名",
    roles: {
      MarketAdministrator: "市场管理员",
      Administrator: "平台管理员",
      Scanner: "扫描员",
      Manager: "经理",
      StockAdministrator: "仓库管理员",
      ReturnAdministrator: "退货管理员",
    },
    pvalid: {
      minLen: "密码至少需要{len}位",
      oneUppercase: "密码至少需包含一个大写字母",
      oneLowercase: "密码至少需包含一个小写字母",
      oneDigit: "密码至少需包含一个数字",
      oneNonLetterOrDigit: "密码至少需包含一个非字母或数字的符号",
    }
  },
  login: {
    usernameRuleMessage: "用户名不可为空",
    passwordRuleMessage: "密码不可为空",
    loginFailure: "登录失败：用户名或密码错误",
    title: "登录",
    rememberMe: "记住用户名",
    placeholder: {
      userName: "请输入用户名",
      password: "请输入密码",
    },
  },
  qrc: {
    title: "QRC码管理",
    historyTitle: "QRC码生成历史",
    generateCode: "生成二维码",
    codeCount: "二维码数量",
    qrcode1: "二维码1",
    qrcode2: "二维码2",
    status: "状态",
    generateTime: "生成时间",
    batchNumber: "批次号",
    statusEnum: {
      Generated: "已生成",
      Manufactured: "已制作",
      Delivered: "已发货",
      Received: "已领取红包",
    },
    changeStatus: "修改状态",
    generate: "生成",
    setCodeStatus: "设置二维码状态",
    batchNumberNotEmpty: "批次号不能为空",
    batchNumberNotExist: "批次号不存在",
    plsSelectStatus: "请选择二维码状态",
    setStatusSuccess: "设置状态成功",
    setStatusFail: "设置状态失败",
    history: "生成历史",
    count: "生成数量",
    generatePerson: "操作人",
    exportCodes: "导出二维码",
  },
  boxScan: {
    title: "装箱扫描",
    scanIn: "扫描录入",
    beginScan: "开始扫描",
    commitScanInfo: "提交扫描",
    commitScanInfoError: "提交扫描信息错误",
    commitScanInfoSuccess: "提交扫描信息成功",
    scanBoxNumber: "请扫描箱号",
    boxNumber: "箱号",
    eanCode: "EAN码",
    qrCode: "二维码",
    productLongCode: "产品长号",
    scanEanCode: "请扫描EAN码",
    scanQRCode: "请扫描二维码",
    eanCheckFail: "未找到对应的EAN码",
    qrcodeCheckFail: "未找到对应的二维码",
    boxNumberScanned: "该箱号已经扫描：{boxNumber}",
    boxNumberFormatterError: "箱号格式错误，必须为20位",
    clearConfirm: "此操作将清空当前所有扫描记录, 是否继续?",
    clearEanConfirm: "确定要清除EAN码[{code}]的扫描记录吗?",
    clearSuccess: "清除成功",
    deleteScanInfoConfirm: "确定要删除箱号[{boxNumber}]的扫描记录吗,删除后无法恢复?",
    submitDialogTitle: "扫描信息确认",
    productCount: "产品总数",
    productBoxCount: "产品盒数",
    boxTotalCount: "产品总数",
    currentBoxNumber: "当前箱号：",
    currentNumber: "当前数量：",
    duplicateQRCode: "该二维码已扫描",
    qrcodeShippedError: "该二维码已发货",
    deliveryScanTime: "扫描时间",
    scanUserName: "扫描员",
    clearEanScanInfo: "清除该产品型号的扫描记录",
    viewScanRecord: "扫描记录",
    completeIWAC: "是否导入IWAC",
    exportScanInfos: "导出",
    importScanInfos: "导入",
    confirmImportScanInfos: "导入操作将覆盖当前的扫描信息，确定导入吗？",
    importScanInfosInvalid: "导入的扫描信息格式错误！",
  },
  delivery: {
    title: "发货信息管理",
    importIWAC: "IWAC导入",
    uploadOneFileMsg: "每次只支持上传一个文件",
    uploadOneQrcMsg: "每次只支持上传一张二维码",
    selectUploadFile: "请选择需要上传的excel文件",
    clickToUpload: "点击上传",
    uploadSuccess: "上传成功",
    customerNumber: "客户号码",
    customerName: "客户名称",
    customerType: "客户类型",
    customerOffice: "客户地区",
    boxNumber: "箱号",
    orderNumber: "订单号",
    boxScanTime: "装箱扫描时间",
    deliveryTime: "发货时间",
    eanCode: "EAN码",
    productLongCode: "产品长号",
    productShortCode: "产品短号",
    amountPerPackage: "单位包装数",
    productSerials: "产品系列号",
    receivedTime: "红包领取时间",
    bonus: "红包金额(元)",
    qrc1: "二维码1",
    qrc2: "二维码2",
    notReceived: "尚未领取",
    ensureScanned: "导入IWAC信息前，请先进行装箱扫描，否则将无法匹配发货信息",
    qrcSearch: "二维码查询",
    uploadQrc: "上传二维码",
    selectUploadQrc: "请选择需要查询的二维码图片",
    resolveQrcodeFail: "未检测到有效的二维码图片",
    downloadTemp: "模板下载",
    codeAuthCount: "防伪查询次数",
    hasReceived: "是否领取红包",
    overview: "概览",
    notExistQrcode:"该二维码信息不存在",
  },
  report: {
    title: "红包领取信息",
    eanCode: "EAN码",
    productLongCode: "产品长号",
    productShortCode: "产品短号",
    productSerials: "产品系列号",
    receivedTime: "红包领取时间",
    bonus: "红包金额(元)",
    customerOffice: "发货地点",
    customerName: "客户名称",
    deliveryTime: "发货时间",
    receiveAddress: "红包领取地址",
    amountPerPackage: "单位包装数量",
    qrc1: "二维码1",
    qrc2: "二维码2",
    batchNumber: "批次号",
    customerNumber: "客户号码",
    customerType: "客户类型",
    scanCount:"一码扫描次数",
    orderCount:"订货数量",
    deliveryCount:"发货数量",
    orderNumber:"订单号",
    salesAreas:"客户销售范围",
  },
  productReturn: {
    title: "退货记录",
    returnScan: "退货扫描",
    remark: "退货备注",
    count: "退货数量",
    userName: "处理人",
    createTime: "退货时间",
    qrcode1: "二维码1",
    eancode: "EAN码",
    longcode: "产品长号",
    boxNumber: "箱号",
    orderNumber: "订单号",
    customerNumber: "客户号",
    customerName: "客户名",
    deliveryTime: "发货日期",
    detail: "详情",
  },
  returnScan: {
    title:"退货扫描",
    scanQrc1:"请扫描退货产品的二维码1",
    returnRecord:"退货记录",
    commitReturn:"确认退货",
    currentInfo:"退货列表：总计 {count}",
    qrcode:"二维码",
    codeStatusError:"该二维码校验错误，无法退货",
    boxNumber:"箱号",
    customerNum:"客户号",
    customerName:"客户名称",
    orderNum:"订单号",
    eanCode:"EAN码",
    pLongCode:"产品长号",
    pShortCode:"产品短号",
    deliveryTime:"发货时间",
    codeScanned:"该二维码已经在退货列表",
    clearConfirm:"此操作将清空当前所有扫描记录, 是否继续?",
    deleteConfirm:"确定删除该退货产品吗?",
    clearSuccess:"清除成功",
    commitConfirmMsg:"请仔细核对退货信息，退货后将不可取消，是否继续?",
    returnSuccess:"退货成功",
    returnRemarkTip:"输入一些退货备注信息吧...",
  },
  EANCodeManagement: "EAN码管理",
  EANCode: "EAN码",
  ProductSerials: "产品系列号",
  ProductLongCode: "产品长号",
  ProductShortCode: "产品短号",
  AmountPerPackage: "每盒产品数量",
  SuggestedRetailPrice:"建议零售价",
  CashbackInformation: "返现信息",
  CashbackAmount: "返现金额",
  EANCodeValidation: "请输入EAN码",
  ProductLongCodeValidation: "请输入产品长号",
  ProductShortCodeValidation: "请输入产品短号",
  CashbackInformationValidation: "请输入返现信息",
  AmountPerPackageValidation: "请输入每箱产品数量",
  SuggestedRetailPriceValidation: "请输入建议零售价",
  IsNumValidation: "请输入正整数",
  ProductSerialsCodeValidation: "产品系列号不可为空",
  editEAN: "编辑EAN码",
  EANAaddedSuccessfully: "EAN码添加成功",
  EANAEditSuccessfully: "EAN码编辑成功",
  DuplicateEANCode: "该EAN码已存在，请核对！",
  DuplicateCodeScanningTimes: "该扫描次数返回信息已存在，请核对！",
  addEAN: "新建EAN码",
  CashbackManagement: "返现管理",
  CashbackAmount: "返现金额",
  EditCashback: "返现信息编辑",

  UserRole: "用户角色",
  ReceivedSalsArea: "销售区域",
  ChannelAccount: "客户号码",
  ChannelType: "客户性质",
  Email: "邮箱",
  ChannelTypeName: "客户分级",
  Remarks: "备注",
  UserType: "客户类别",
  UserType0: "直销客户",
  UserType1: "工业分销商",
  UserType2: "建筑连接器分销商-零售渠道",
  UserType3: "建筑连接器分销商-工程渠道",
  UserType4: "建筑连接器分销商-电商渠道",
  UserType5: "工业代理商",
  UserType6: "系统集成商",
  UserType7: "WAGO用户",
  UserType8: "建筑直销渠道",
  UserType9: "建筑连接器分销商-家装渠道",
  UserType10:"工业贸易商",
  editCashback: "编辑返现信息",
  CashbackAmountValidation: "返现金额不能为空",
  CashbackEditSuccessfully: "返现信息编辑成功",
  CMUserView: "客户信息",
  BICustomName: "客户名称",
  Office: "办事处",
  WagoABUBBUManager: "WAGO ABU/BBU经理",
  ChannelCustomer: "渠道客户",
  WagoSales: "WAGO 销售人员",
  WagoRegionManager: "WAGO 大区经理",
  Administrator: "系统管理员",
  WagoOfficeManager: "WAGO 办事处经理",
  WagoChannelManager: "WAGO 渠道经理",
  WagoSalesMarketingManager: "WAGO 销售市场总经理",
  WagoExpressAdministrator: "WAGO 物流管理员",
  WagoComplatintAdministrator: "投诉管理员",
  WagoQualityAdministrator: "质量管理员",
  WagoStockAdministrator: "库存管理员",
  addCodeScanningSuccessfully: "添加扫码返回信息成功！",
  editCodeScanningSuccessfully: "编辑扫码返回信息成功！",
  WagoCEO: "公司总裁",
  SalesArea: "销售区域",
  UserRoles: "用户角色",
  RoleType0: "系统管理员",
  RoleType1: "渠道客户",
  RoleType2: "WAGO 销售人员",
  RoleType3: "WAGO 办事处经理",
  RoleType4: "WAGO 渠道经理",
  RoleType5: "WAGO 大区经理",
  RoleType6: "WAGO ABU/BBU经理",
  RoleType7: "WAGO 销售市场总经理",
  RoleType9: "WAGO 物流管理员",
  RoleType10: "WAGO 投诉管理员",
  RoleType11: "WAGO 质量管理员",
  RoleType12: "WAGO 库存管理员",
  RoleType13: "公司总裁",
  BU: "BU",
  QRC1: "二维码1",
  QRC2: "二维码2",
  editCodeScanning: "编辑扫码显示信息",
  addCodeScanning: "新建扫码显示信息",
  CodeTypeValidation: "扫码类型不能为空",
  UserTypeCodeValidation: "客户类型不能为空",
  ScanningTimesValidation: "扫描次数不能为空",
  ScanningMessageValidation: "扫码显示信息不能为空",
  CodeScanningInformation: "扫码显示信息",
  ScanningTimes: "扫描次数",
  ScanningMessage: "扫码显示信息",
  CodeType: "扫码类型",

  operationFailure: "操作失败",
  modify: "修改",
  save: "保存",
  cancel: "取消",
  search: "搜索",
  confirm: "确定",
  refresh: "刷新",
  add: "新建",
  edit: "编辑",
  delete: "删除",
  tip: "提示",
  from: "从",
  to: "到",
  reset: "重置",
  setup: "设置",
  export: "导出",
  back: "返回",
  submit: "提交",
  total: "总计",
  operation: "操作",
  deleteSuccess: "删除成功",
  deleteFail: "删除失败",
  upload: "上传",
  query: "查询",
  serialNumber: "序号",
  activation: "启用红包",
  inActivation: "禁用红包",
  deleteSuccess: "删除成功",
  deleteFail: "删除失败",
  upload: "上传",
  query: "查询",
}


// WEBPACK FOOTER //
// ./src/international/zh.js